import { action } from 'easy-peasy';
import { IActionShowError } from '~/store/snackbar/types';

const showError: IActionShowError = action((state, payload) => {
  state.message = payload;
  state.isError = true;
});

export default showError;
